module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/031-corsica-415f441c0dfca620c97812865b62158c.svg";